import React from 'react'
import { CCol, CFormSelect, CRow } from '@coreui/react-pro'
import { useAppDispatch, useTypedSelector } from '../../stateStore'
import { reduxServices } from '../../reducers/reduxServices'

type PageSizeChangeCallbackType = (pageNumber: number, size: number) => void

const OPageSizeSelectRevised = ({
  options = [20, 40, 80, 100],
  changeCallback,
}: {
  options?: number[]
  changeCallback?: PageSizeChangeCallbackType
}): JSX.Element => {
  const dispatch = useAppDispatch()

  const recentCache = useTypedSelector(
    reduxServices.app.selectors.selectRecentPageWithList,
  )

  const selectedPageSize = recentCache.pageSize ?? options[0]

  const handlePageSizeSelectChange = (
    event: React.ChangeEvent<HTMLSelectElement>,
  ) => {
    dispatch(
      reduxServices.app.actions.setCachedPageSize(Number(event.target.value)),
    )
    dispatch(
      reduxServices.app.actions.setStoredCache({
        page: 1,
        size: Number(event.target.value),
      }),
    )
    if (changeCallback) changeCallback(1, Number(event.target.value))
  }

  return (
    <CRow className="g-1 align-items-center">
      <CCol xs="auto">
        <p>Display</p>
      </CCol>
      <CCol xs="auto">
        <CFormSelect
          data-testid="test-page-size"
          size="sm"
          className="mb-3"
          onChange={handlePageSizeSelectChange}
          value={selectedPageSize.toString()}
        >
          {options.map((value, index) => (
            <option key={index} value={value.toString()}>
              {value}
            </option>
          ))}
        </CFormSelect>
      </CCol>
      <CCol xs="auto">
        <p>Per page</p>
      </CCol>
    </CRow>
  )
}

export default OPageSizeSelectRevised
